module.exports = __webpack_public_path__ + "static/img/android.06c201c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/android.png
// module id = LbF0
// module chunks = 1